// In-memory health log accumulation (no backend POST)

let logs = [];

export const HEALTH_LOG_DIR = 'memory'; // conceptual label

export function initRemoteHealthLog() {
  logs = [];
  logs.push('--- Session started ' + new Date().toISOString() + ' ---');
}

export function appendHealthLogLine(line) {
  logs.push(line);
}

export function forceFlushHealthLogs() {
  // no-op (no backend flush)
}

export function getAllLogs() {
  return logs.slice();
}
